import React, { FC, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import { EmphaticText, LabelWrapper, LetterImg } from './style.css';
import TrackingEvents from '../../common/models/TrackingEvents';
import Store from '../../common/models/Store';
import { trackAction } from '../../common/actions/trackingActions';
import { scrollToY } from '../../helpers/animatedScrolling';

const NewsletterModalButton: FC<{ header?: boolean }> = ({ header }) => {
  const [formElement, setFormElement] = useState(null);
  const dispatch = useDispatch();
  const s3BasePath = useSelector<Store, string>(state => state.api.s3BasePath);

  useEffect(() => {
    setFormElement(
      document.querySelector('#klaviyo-embed-footer') || document.querySelector('#klaviyo-embed-homepage'),
    );
  }, []);

  const handleClick = (): void => {
    scrollToY(get(formElement, 'offsetTop') - 215);
    dispatch(trackAction(TrackingEvents.newsletterSubscribeSelected()));
  };

  return (
    <>
      <LabelWrapper data-cy="wrapper-newsletter-open-modal" header={header} onClick={handleClick}>
        <LetterImg header={header} src={`${s3BasePath}mkt/icon/icon_newsletter.png`} />
        <EmphaticText header={header}>
          subscribe <span>to save</span>
        </EmphaticText>
      </LabelWrapper>
    </>
  );
};

export default NewsletterModalButton;
